'use strict'
if (process.env.NODE_ENV === 'production') {
  module.exports = require('./rtk-query.production.min.cjs')
} else {
  module.exports = require('./rtk-query.development.cjs')
}